import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = false, allowExpired = false }) {
  const { user, access, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090B]" data-testid="auth-loading">
        <Loader2 className="w-7 h-7 animate-spin text-[#0055FF]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  // Hard-lock: if trial expired AND no active subscription, redirect everything except whitelisted routes
  const path = location.pathname;
  const exempt = allowExpired
    || path.startsWith("/account")
    || path.startsWith("/admin")
    || path.startsWith("/upgrade")
    || path.startsWith("/billing");
  if (access && access.locked && !exempt) {
    return <Navigate to="/upgrade" replace />;
  }
  return children;
}
